import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useSportUrlParams } from '@mwl/core-lib';
import { routes } from '@/constants';
import { useIsCyberSportPage } from '@/hooks';
import type { MobileFilterElements } from './MobileModeFilter.types';
export const useMobileFilterElements = (): MobileFilterElements => {
  const {
    t
  } = useTranslation('sport');
  const router = useRouter();
  const {
    stage,
    createStageLink
  } = useSportUrlParams({
    routes
  });
  const isCyberSportPage = useIsCyberSportPage();
  return {
    top: {
      sectionName: 'top',
      isActive: (router.pathname === routes.sport.home || router.pathname === routes.esports.home) && !stage,
      href: isCyberSportPage ? routes.esports.home : routes.sport.home,
      text: t('filters.top', 'Top')
    },
    live: {
      sectionName: 'live',
      isActive: stage === 'LIVE',
      href: createStageLink('LIVE'),
      text: t('filters.live', 'Live')
    },
    pregame: {
      sectionName: 'pregame',
      isActive: stage === 'PREGAME',
      href: createStageLink('PREGAME'),
      text: t('filters.pregame', 'Pregame')
    },
    favorites: {
      sectionName: 'favorites',
      isActive: [routes.sport.favorites, routes.esports.favorites].includes(router.pathname),
      href: isCyberSportPage ? routes.esports.favorites : routes.sport.favorites,
      text: t('filters.favorites', 'Favorites')
    }
  };
};